import React from 'react';
import { useTranslation } from 'react-i18next';
import CountUp from 'react-countup';
import { Users, FileText, Home, Star } from 'lucide-react';

const stats = [
    { icon: Users,     number: 1680, suffix: '+', labelKey: 'guestsHosted',        color: '#fb854d' },
    { icon: FileText,  number: 420,  suffix: '+', labelKey: 'reservationsManaged', color: '#5370e2' },
    { icon: Home,      number: 35,   suffix: '+', labelKey: 'propertiesManaged',   color: '#47b5b9' },
    { icon: Star,      number: 5,    suffix: '★', labelKey: 'starRating',          color: '#d89d37' },
];

const CounterBlog = () => {
    const { t } = useTranslation();

    return (
        <div className="stats-bar">
            {stats.map((s) => {
                const Icon = s.icon;
                return (
                    <div className="stats-bar-item" key={s.labelKey}>
                        <div className="stats-bar-icon">
                            <Icon size={24} color={s.color} strokeWidth={2} />
                        </div>
                        <div className="stats-bar-number">
                            <CountUp end={s.number} duration={3} />
                            {s.suffix}
                        </div>
                        <div className="stats-bar-label">{t(`counter.${s.labelKey}`)}</div>
                    </div>
                );
            })}
        </div>
    );
};

export default CounterBlog;